export default __webpack_public_path__ + "static/media/mesh_steelgrid.4d0f69a7.png";